import { AxiosResponse, AxiosError } from 'axios';
//
import { ECostFormulaActionType } from 'store/cost-formulas/types';
import apiService from 'services/api';
import apiRoutes from 'services/api/routes';
import { getAccessToken } from 'lib/auth';
import { getAxiosErrorMessage } from 'lib/helpers/error-handler';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

export const getCostFormulas = () => (dispatch: ThunkDispatch<void, void, AnyAction>) =>
  new Promise<void>((resolve, reject) => {
    dispatch({
      type: ECostFormulaActionType.GET_COST_FORMULAS,
    });

    apiService
      .get(apiRoutes.manufacturingCostFormulas, {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      })
      .then((response: AxiosResponse) => {
        dispatch({
          type: ECostFormulaActionType.GET_COST_FORMULAS_SUCCESS,
          formulaGroups: response.data,
        });
        resolve();
      })
      .catch((error: AxiosError) => {
        const errorMessage = getAxiosErrorMessage(error);
        if (!error.message.includes('401')) {
          dispatch({
            type: ECostFormulaActionType.GET_COST_FORMULAS_FAIL,
            error: errorMessage,
          });
        }
        reject(error);
      });
  });
